import type { ReactNode } from 'react'
import './table.css'

/**
 * Lets a table scroll sideways INSIDE its card instead of widening the whole page.
 *
 * A table cannot shrink below its content, and at phone width the members table and the report's
 * findings table were wider than the screen -- so the entire page scrolled horizontally, taking the
 * app bar and every other card with it. The overflow now stays with the table that caused it.
 *
 * Focusable and labelled because a region that only scrolls is otherwise unreachable from the
 * keyboard (WCAG 2.1.1): the label says what the region holds, and arrow keys scroll it once focused.
 */
export function TableScroll({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="table-scroll" role="region" aria-label={label} tabIndex={0}>
      {children}
    </div>
  )
}
